import { ProjectTypeEnum, type ModelLog } from "@repo/schema";
import { useTranslation } from "react-i18next";
import {
  headlineDualSeries,
  headlineSeriesConfig,
} from "../../utils/headlineMetric";
import { ModelLogs } from "../ModelLogs";
import { ModelMetrics } from "../ModelMetrics";
import { TrainingChart } from "../TrainingChart";

const hasMapHeadline = (trainingType: ProjectTypeEnum | undefined): boolean =>
  trainingType === ProjectTypeEnum.DETECTION ||
  trainingType === ProjectTypeEnum.SEGMENTATION;

export interface ModelOverviewProps {
  modelName: string | undefined;
  logs: ModelLog[] | undefined;
  trainingType: ProjectTypeEnum | undefined;
}

export const ModelOverview = ({
  modelName,
  logs,
  trainingType,
}: ModelOverviewProps) => {
  const { t } = useTranslation(["model", "common"]);
  return (
    <div className="flex min-h-0 flex-1 flex-col gap-4 pb-8">
      {modelName && <h2 className="text-xl font-bold">{modelName}</h2>}
      <div className="grid grid-cols-2 gap-4">
        <TrainingChart
          title={
            hasMapHeadline(trainingType)
              ? t("metrics.modelPerformance")
              : t("metrics.accuracy")
          }
          data={trainingType ? headlineDualSeries(logs, trainingType) : []}
          series={trainingType ? headlineSeriesConfig(trainingType, t) : []}
        />
        <TrainingChart
          title={t("metrics.loss")}
          series={[{ key: "value", label: t("metrics.loss") }]}
          data={
            logs?.map((log) => ({
              value: log.metrics.loss,
              epoch: log.epoch,
            })) ?? []
          }
        />
      </div>
      <ModelMetrics />
      <ModelLogs />
    </div>
  );
};
